import React from "react";
import { GenericPage } from "../../../../../pages";

import { bankRoute } from "./models-bank.route";
import { catalogueRoute } from "./models-catalogue.route";
import { moduleRoute } from "./models-module.route";
import { optionRoute } from "./models-options.route";
import { taskRoute } from "./models-task.route";
import { cantonRoute } from "./models-canton";
import { countryRoute } from "./models-country";
import { provinceRoute } from "./models-province.route";
import { parishRoute } from "./models-parish.route";


export const modelsRoute = [
  {
    path: 'banks',
    element: <GenericPage />,
    children: bankRoute,
  },
  {
    path: 'catalogues',
    element: <GenericPage />,
    children: catalogueRoute,
  },
  {
    path: 'cantons',
    element: <GenericPage />,
    children: cantonRoute,
  },
  {
    path: 'countries',
    element: <GenericPage />,
    children: countryRoute,
  },
  {
    path: 'modules',
    element: <GenericPage />,
    children: moduleRoute,
  },
  {
    path: 'options',
    element: <GenericPage />,
    children: optionRoute,
  },
  {
    path: 'parishes',
    element: <GenericPage />,
    children: parishRoute,
  },
  {
    path: 'provinces',
    element: <GenericPage />,
    children: provinceRoute,
  },
  {
    path: 'tasks',
    element: <GenericPage />,
    children: taskRoute,
  },
]